import React, { useEffect, useRef, useState } from "react";
import { 
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _isHouse
} from "../../helpers/utils";
function ProfileLoadingCard(props) {
  var data = props.data || {};
  var messageType = props.messageType || "search";
  var stepMs = Number(props.stepMs || 2500);

  var [idx, setIdx] = useState(0);
  var timerRef = useRef(null);

  var MESSAGE_SETS = {
	search: [
	  "Gathering contact and identity signals…",
	  "Matching records and cleaning up addresses…",
	  "Cross-checking phone and email candidates…",
	  "Verifying the match so it’s not a guess…",
	  "Still working… this one has a few extra threads.",
	  "Almost there. Running a final accuracy pass…",
	  "Just a moment longer. We’d rather be right than fast."
	],
	full: [
	  "Building a unified profile across contact, address, and work…",
	  "Linking records and removing duplicates…",
	  "Resolving identity across sources…",
	  "Organizing everything into a clean profile summary…",
	  "Still compiling… the profile is getting sharper.",
	  "Final checks: consistency and formatting…",
	  "Almost done. Polishing for export and outreach."
	],
	company: [
	  "Collecting building context…",
	  "Matching records across sources…",
	  "Normalizing addresses and identifiers…",
	  "Pulling key attributes and history…",
	  "Still working… almost there."
	]
  };

  var messages = MESSAGE_SETS[messageType] || MESSAGE_SETS.search;

  function scheduleNext() {
	clearTimeout(timerRef.current);
	timerRef.current = setTimeout(function () {
	  setIdx(function (prev) {
		if (prev >= messages.length - 1) return prev;
		return prev + 1;
	  });
	}, stepMs);
  }

  // advance message index
  useEffect(function () {
	scheduleNext();
	return function () {
	  clearTimeout(timerRef.current);
	};
  }, [idx, stepMs, messages.length]);

  // restart when type changes
  useEffect(function () {
	setIdx(0);
  }, [messageType]);

  // ---- Title / initials / location derived from data ----
  // You can override any of these via props if needed later.
  function _cap(str) {
	if (props.capitalizeText) return props.capitalizeText(str);
	return str;
  }

  var firstName = data.first_name || data.firstName || "";
  var lastName = data.last_name || data.lastName || "";
  var hasName = !!(firstName || lastName);

  var titleText = hasName
	? (String(_cap(firstName) || "") + " " + String(_cap(lastName) || "")).trim()
	: (messageType === "full" ? "Building full profile…" : "Searching…");
	
  if(messageType == 'company' && data.triggerDisplay){
	  titleText = data.triggerDisplay.toUpperCase();
  }

  var initials = "";
  if (props.getInitials) {
	initials = props.getInitials(data);
  } else {
	// small default initials helper
	var a = (firstName || "").trim();
	var b = (lastName || "").trim();
	initials = (a ? a.charAt(0) : "") + (b ? b.charAt(0) : "");
	initials = (initials || "").toUpperCase();
  }

  var locationText = "";
  if (props.getLocation) {
	locationText = props.getLocation(data);
  } else if (props.formatAddress) {
	locationText = props.formatAddress(data);
  }

  var subtitleText = messages[idx] || "";

  return (
	<div className="skiptrace-profile-card skiptrace-profile-card--ai">
	  <div className="skiptrace-profile-header">
		<div className="skiptrace-profile-avatar">
		  <span>{initials || (hasName ? "?" : "…")}</span>
		</div>

		<div className="skiptrace-profile-header-main">
		  <div className="skiptrace-profile-name-row">
			<span className="skiptrace-profile-name">{titleText}</span>
		  </div>

		  {locationText ? (
			<div className="skiptrace-profile-meta-row">
			  {props.MapMarkerIcon ? <props.MapMarkerIcon size={16} /> : null}
			  <span className="skiptrace-profile-meta-label">{locationText}</span>
			</div>
		  ) : null}
		</div>
	  </div>

	  <div className="skiptrace-profile-divider" />

	  <div className="skiptrace-profile-body skiptrace-profile-body--loading">
		<div style={{ width: "100%" }}>
		  {props.LinearLoading ? <props.LinearLoading /> : null}
		  <p className="skiptrace-loading-text">{subtitleText}</p>
		</div>
	  </div>
	</div>
  );
}

export default ProfileLoadingCard;
